import React from 'react';
import './form.css';
import FormWrapper from '../FormWrapper';
import { useModal } from '../../../../context/ModalContext';

const ContactUsPopUp = () => {
    const { modals, closeModal } = useModal();
    return (
        <FormWrapper
            open={modals.contact}
            handleClose={() => closeModal('contact')}
            heading="Contact Us"
            subTitle="Submit the form and we will get back to you as soon as possible."
            targetId="hubspotForm"
            formId={process.env.GATSBY_HUBSPOT_CONTACT_FORM_ID}
            confirmationMessage="Thank you for your message. We will get back to you shortly."
        />
    );
};

export default ContactUsPopUp;
